export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";
export const isLocal = process.env.NEXT_PUBLIC_VERCEL_ENV === "local";
export const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
export const isDevelopment =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development";

export const getEnvironment = () => {
  if (isProduction) return "production";
  if (isPreview) return "preview";
  return "development";
};
